var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down_next_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "next_arrow",
    d: "M18.4224 23.7385C17.6304 24.4405 16.416 24.3721 15.7127 23.5789C15.0083 22.7857 15.0791 21.5724 15.8723 20.868L20.7373 16.5431H15.2266C7.28585 16.5431 0.826172 10.0834 0.826172 2.14271C0.826172 1.08309 1.6866 0.222658 2.74623 0.222658C3.80585 0.222658 4.66628 1.08309 4.66628 2.14271C4.66628 7.96524 9.40405 12.703 15.2266 12.703H20.7373L15.8723 8.37813C15.0791 7.6737 15.0083 6.46047 15.7127 5.66726C16.0907 5.24125 16.6176 5.02282 17.1468 5.02282C17.6004 5.02282 18.0564 5.18243 18.4212 5.50763L27.0614 13.1878C27.473 13.5527 27.7071 14.0747 27.7071 14.6231C27.7071 15.1715 27.4731 15.6935 27.0626 16.0583L18.4224 23.7385Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownNextArrow);
export default __webpack_public_path__ + "static/media/down_next_arrow.9db1afc222f225cf8fe628de3415fbc3.svg";
export { ForwardRef as ReactComponent };